module.exports = (__parcel__import__("lCo7C")).then(() => parcelRequire('ahP7X'));